export const siteConfig = {
  name: '豆包成人版',
  tagline: '专为成年人打造的AI智能助手',
  description: '豆包成人版是专为成年人设计的AI智能对话助手，提供更深度、更专业的内容支持。无论是职场效率、深度学习还是复杂问题解决，豆包成人版都能满足成年用户的多元化需求。',
  url: 'https://doubao-adult.ai',
  logo: '豆包成人版',
  contactEmail: 'contact@doubao-adult.ai',
  contactPhone: '400-888-8888',
  address: '北京市海淀区中关村科技园',
};

export const navLinks = [
  { label: '首页', href: '/' },
  { label: '功能分类', href: '/category/features' },
  { label: '使用教程', href: '/category/tutorials' },
  { label: '关于我们', href: '/about' },
];

export const categories = [
  { slug: 'features', name: '功能特色', description: '探索豆包成人版强大的AI功能' },
  { slug: 'tutorials', name: '使用教程', description: '从入门到精通的使用指南' },
  { slug: 'comparison', name: '版本对比', description: '豆包成人版与普通版的详细对比' },
  { slug: 'download', name: '下载指南', description: '各平台下载安装教程' },
  { slug: 'qa', name: '常见问题', description: '用户最关心的问答合集' },
];

export const articles = [
  {
    id: 'article-1',
    slug: 'doubao-adult-introduction',
    title: '豆包成人版全面介绍：更专业的AI智能助手',
    summary: '深入了解豆包成人版的核心功能与技术优势，看它如何帮助成年人提升工作效率。',
    content: `<p>在人工智能快速发展的今天，豆包成人版作为一款专为成年人打造的AI智能助手，正以其卓越的性能和深度的专业能力，重新定义人们与AI的交互方式。</p>
<h2>什么是豆包成人版？</h2>
<p>豆包成人版是在豆包基础版之上，专门针对成年用户需求进行深度优化的高级版本。它不仅保留了基础版的便捷性，更在内容深度、专业性和功能丰富度上有了质的飞跃。</p>
<h2>核心优势</h2>
<p>与普通版相比，豆包成人版在多个维度上进行了升级：更强大的语境理解能力、更专业的领域知识覆盖、更精准的复杂问题解答。无论是撰写商业报告、进行市场分析，还是解决技术难题，豆包成人版都能提供远超普通版的智能支持。</p>
<h2>适用场景</h2>
<p>职场人士可以利用豆包成人版快速完成文档撰写、数据分析、方案策划等工作；研究人员可以借助其深度学习能力进行文献综述、实验设计；创业者则可以用它进行商业计划书撰写、竞品分析等。</p>
<p>豆包成人版的出现，让AI不再是简单的聊天工具，而是真正能助力成年人事业发展的智能伙伴。</p>`,
    category: 'features',
    image: 'https://readdy.ai/api/search-image?query=Modern%20professional%20AI%20assistant%20interface%20on%20a%20sleek%20laptop%20screen%2C%20warm%20minimalist%20workspace%20with%20soft%20natural%20lighting%2C%20clean%20professional%20aesthetic%2C%20coffee%20cup%20on%20wooden%20desk%2C%20editorial%20photography%20style%20with%20elegant%20composition&width=1200&height=600&seq=doubao-feature-01&orientation=landscape',
    author: '豆包团队',
    date: '2026-07-15',
    readTime: '8分钟',
    tags: ['AI助手', '功能介绍', '豆包成人版'],
  },
  {
    id: 'article-2',
    slug: 'doubao-features-guide',
    title: '豆包成人版五大核心功能详解',
    summary: '详细解读豆包成人版的五大核心功能，帮助你快速上手并充分发挥AI的潜力。',
    content: `<p>豆包成人版集成了多项创新功能，每一项都经过精心设计，以满足成年用户在工作、学习和生活中的实际需求。下面让我们逐一了解这些强大的核心功能。</p>
<h2>1. 深度对话模式</h2>
<p>不同于普通版的浅层对话，深度对话模式能够进行多轮、有记忆的复杂交流。AI会记住上下文，理解你的真实意图，给出更具洞察力的回复。在讨论复杂商业策略或学术问题时，这一功能的价值尤为突出。</p>
<h2>2. 专业文档生成</h2>
<p>支持一键生成高质量的商业文档、学术论文、技术报告等。内置多种专业模板，涵盖商务、科技、教育等多个领域，让文档创作变得轻松高效。</p>
<h2>3. 数据分析助手</h2>
<p>上传数据表格，豆包成人版可以自动进行数据分析、趋势预测，并生成可视化报告。无论是销售数据、用户调研还是市场趋势，都能快速获得有价值的洞察。</p>
<h2>4. 多语言专业翻译</h2>
<p>相比普通版的通用翻译，成人版提供领域专业翻译，在商务、法律、医学等专业领域的翻译质量上有显著提升，确保术语准确、表达地道。</p>
<h2>5. 个性化知识库</h2>
<p>用户可以构建专属知识库，豆包成人版会学习并记忆你的偏好和专业领域，随着使用时间增长，AI会越来越了解你的需求，提供更加个性化的服务。</p>`,
    category: 'features',
    image: 'https://readdy.ai/api/search-image?query=Five%20colorful%20floating%20UI%20cards%20displaying%20AI%20features%20on%20a%20clean%20light%20background%2C%20minimalist%20tech%20design%2C%20warm%20amber%20and%20teal%20accents%2C%20modern%20professional%20aesthetic%20with%20soft%20shadows&width=1200&height=600&seq=doubao-feature-02&orientation=landscape',
    author: '豆包团队',
    date: '2026-07-20',
    readTime: '10分钟',
    tags: ['功能介绍', '豆包成人版功能', '使用教程'],
  },
  {
    id: 'article-3',
    slug: 'doubao-vs-regular',
    title: '豆包成人版与普通版的五大区别',
    summary: '一次看懂豆包成人版和普通版的核心差异，帮你判断哪个版本更适合你。',
    content: `<p>很多用户在初次接触豆包时都会问：成人版和普通版到底有什么区别？值不值得升级？本文将从五个关键维度为你详细对比。</p>
<h2>1. 内容深度</h2>
<p>普通版适合日常闲聊、简单问答和信息查询；成人版则能处理深度分析、专业咨询和复杂推理，回复内容更加系统和全面。</p>
<h2>2. 专业领域覆盖</h2>
<p>普通版覆盖通用知识领域；成人版额外强化了商业管理、金融投资、法律咨询、医学科普、技术开发等专业领域的知识库，在专业问题上表现更出色。</p>
<h2>3. 对话记忆能力</h2>
<p>普通版的对话记忆有限，长时间对话容易丢失上下文；成人版拥有增强的上下文窗口，可以在更长的对话中保持连贯性和一致性。</p>
<h2>4. 个性化定制</h2>
<p>普通版提供标准化的AI服务；成人版支持个性化设置，用户可以根据自己的职业、兴趣和使用习惯定制AI的回复风格和知识侧重。</p>
<h2>5. 输出质量</h2>
<p>普通版输出内容较为通用；成人版的输出在逻辑性、专业性和实用性上都有显著提升，更适合用于正式的工作场景。</p>`,
    category: 'comparison',
    image: 'https://readdy.ai/api/search-image?query=Side%20by%20side%20comparison%20of%20two%20smartphone%20screens%20showing%20different%20AI%20assistant%20interfaces%2C%20one%20simple%20one%20more%20advanced%2C%20clean%20minimalist%20product%20photography%20on%20light%20background%2C%20warm%20professional%20aesthetic&width=1200&height=600&seq=doubao-comparison&orientation=landscape',
    author: '产品经理小李',
    date: '2026-07-22',
    readTime: '6分钟',
    tags: ['版本对比', '豆包成人版与普通版区别', '豆包成人版功能'],
  },
  {
    id: 'article-4',
    slug: 'doubao-install-guide',
    title: '豆包AI成人版下载与安装完整教程',
    summary: '保姆级下载安装指南，手把手教你如何在手机和电脑上安装豆包成人版。',
    content: `<p>想要体验豆包成人版的强大功能？首先需要正确下载和安装。本教程将覆盖iOS、Android、Windows和macOS四大平台，确保你顺利上手。</p>
<h2>iOS用户安装步骤</h2>
<p>打开App Store，搜索"豆包"，在搜索结果中找到带有"成人版"标识的版本，点击获取并安装。安装完成后，使用手机号或邮箱注册账号即可开始使用。</p>
<h2>Android用户安装步骤</h2>
<p>打开官方应用商店（如华为应用市场、小米应用商店等），搜索"豆包成人版"，下载安装即可。也可以通过官方网站下载APK安装包进行手动安装。</p>
<h2>Windows/Mac桌面版</h2>
<p>访问豆包官方网站，在下载页面选择对应操作系统的版本。下载完成后，运行安装程序，按照引导完成安装。桌面版支持快捷键唤醒，使用更加便捷。</p>
<h2>首次使用设置建议</h2>
<p>安装完成后，建议先完成个性化设置：填写职业信息、选择感兴趣的领域、设置语言偏好等。这些设置将帮助豆包成人版更好地理解你的需求，提供更精准的服务。</p>`,
    category: 'download',
    image: 'https://readdy.ai/api/search-image?query=Multiple%20devices%20showing%20app%20download%20screen%2C%20iPhone%20Android%20and%20laptop%20arranged%20on%20a%20clean%20wooden%20desk%2C%20warm%20natural%20lighting%2C%20minimalist%20tech%20lifestyle%20photography%2C%20professional%20aesthetic&width=1200&height=600&seq=doubao-download&orientation=landscape',
    author: '技术支持小张',
    date: '2026-07-25',
    readTime: '7分钟',
    tags: ['下载教程', '豆包AI成人版下载', '使用教程'],
  },
  {
    id: 'article-5',
    slug: 'doubao-workplace-efficiency',
    title: '如何用豆包成人版提升三倍职场效率',
    summary: '职场达人都在用的AI效率秘诀，学会这些技巧让你的工作效率翻倍。',
    content: `<p>在快节奏的职场环境中，效率就是竞争力。越来越多的职场精英开始使用豆包成人版来提升工作效率，本文将分享实用的AI效率技巧。</p>
<h2>邮件撰写与回复</h2>
<p>不再为写邮件发愁。只需告诉豆包成人版邮件的核心内容和语气要求，它就能生成专业、得体的邮件草稿。商务谈判、客户沟通、内部汇报，各种场景轻松应对。</p>
<h2>会议纪要自动化</h2>
<p>将会议录音转为文字后，豆包成人版可以自动提炼关键决策、行动项和截止日期，生成结构清晰的会议纪要，省去手动整理的时间。</p>
<h2>PPT与报告生成</h2>
<p>输入核心观点和数据，豆包成人版可以生成完整的PPT大纲和内容文案，甚至提供视觉设计建议，让汇报准备效率大幅提升。</p>
<h2>行业研究加速</h2>
<p>需要进行竞品分析或行业调研？豆包成人版可以快速汇总公开信息，提供结构化的研究报告框架，帮你节省大量搜索和整理时间。</p>`,
    category: 'tutorials',
    image: 'https://readdy.ai/api/search-image?query=Professional%20workspace%20with%20laptop%20showing%20AI%20dashboard%2C%20productivity%20tools%20on%20minimalist%20desk%2C%20warm%20lighting%20from%20window%2C%20clean%20modern%20office%20aesthetic%2C%20elegant%20and%20focused%20atmosphere&width=1200&height=600&seq=doubao-workplace&orientation=landscape',
    author: '效率达人王磊',
    date: '2026-07-28',
    readTime: '9分钟',
    tags: ['职场效率', '使用教程', '成人AI智能助手'],
  },
  {
    id: 'article-6',
    slug: 'doubao-deep-learning',
    title: '豆包成人版助力深度学习：从入门到精通',
    summary: '利用豆包成人版的深度学习功能，系统化地掌握任何新知识和技能。',
    content: `<p>终身学习是成年人的必修课。豆包成人版的深度学习功能让系统化学习变得前所未有的轻松和高效。</p>
<h2>制定学习计划</h2>
<p>告诉豆包成人版你想学习的领域和目标时间，它会为你生成详细的学习路线图，包括每日学习任务、推荐资源和阶段性目标。</p>
<h2>交互式知识问答</h2>
<p>在学习过程中遇到不理解的概念，随时向豆包成人版提问。它不仅能解释概念，还能通过举例、类比等方式帮你真正理解。</p>
<h2>知识体系构建</h2>
<p>豆包成人版可以帮你将零散的知识点串联成完整的知识体系，通过思维导图式的梳理，让你对学习内容有全局性的把握。</p>
<h2>进度跟踪与反馈</h2>
<p>定期与豆包成人版进行知识检验，AI会评估你的掌握程度，指出薄弱环节，并调整后续学习计划，确保学习效果最大化。</p>`,
    category: 'tutorials',
    image: 'https://readdy.ai/api/search-image?query=Person%20studying%20with%20AI%20assistant%20on%20tablet%2C%20warm%20cozy%20study%20room%20with%20bookshelf%2C%20soft%20ambient%20lighting%2C%20minimalist%20and%20focused%20learning%20environment%2C%20modern%20lifestyle%20photography&width=1200&height=600&seq=doubao-learning&orientation=landscape',
    author: '学习教练陈芳',
    date: '2026-07-30',
    readTime: '8分钟',
    tags: ['深度学习', '成人AI智能助手', '使用教程'],
  },
  {
    id: 'article-7',
    slug: 'doubao-security-privacy',
    title: '豆包成人版隐私安全保护机制全解析',
    summary: '深入了解豆包成人版的数据安全和隐私保护措施，让你用得放心。',
    content: `<p>在使用AI助手时，数据隐私和安全是用户最关心的问题之一。豆包成人版在这方面投入了大量资源，建立了一套完善的安全防护体系。</p>
<h2>端到端加密</h2>
<p>所有用户与豆包成人版的对话内容均采用端到端加密传输，确保数据在传输过程中不被窃取或篡改。</p>
<h2>数据本地化存储</h2>
<p>用户的个人数据严格存储在境内服务器，符合国家数据安全法规要求。用户可以随时查看、导出或删除自己的数据。</p>
<h2>对话内容隔离</h2>
<p>每次对话都是独立的，豆包成人版不会在不同用户或不同会话之间交叉使用对话数据。你的隐私始终得到保护。</p>
<h2>透明的数据处理政策</h2>
<p>豆包成人版提供清晰易懂的隐私政策，明确告知用户哪些数据被收集、如何使用以及存储期限，确保用户知情权。</p>`,
    category: 'features',
    image: 'https://readdy.ai/api/search-image?query=Digital%20security%20shield%20concept%20with%20lock%20icon%20on%20clean%20background%2C%20warm%20minimalist%20design%2C%20soft%20gradient%20in%20amber%20and%20teal%20tones%2C%20modern%20professional%20tech%20aesthetic&width=1200&height=600&seq=doubao-security&orientation=landscape',
    author: '安全工程师刘洋',
    date: '2026-08-01',
    readTime: '7分钟',
    tags: ['安全隐私', '豆包成人版功能', '成人AI智能助手'],
  },
  {
    id: 'article-8',
    slug: 'doubao-freelancer-guide',
    title: '自由职业者如何靠豆包成人版月入翻倍',
    summary: '自由职业者利用AI助手提升服务质量和效率的实战经验分享。',
    content: `<p>作为一名自由职业者，时间就是金钱。豆包成人版帮助我在过去三个月内将收入提升了120%，今天来分享我的实战经验。</p>
<h2>客户提案快速生成</h2>
<p>以前写一份客户提案需要半天时间，现在用豆包成人版只需要30分钟。输入项目需求，AI就能生成结构完整、专业度高的提案框架，我只需要做少量调整即可。</p>
<h2>内容创作效率翻倍</h2>
<p>作为自媒体创作者，每天需要产出大量内容。豆包成人版帮我进行选题策划、大纲拟定和初稿撰写，让我从日更一篇变成了日更三篇。</p>
<h2>多客户管理</h2>
<p>同时服务多个客户时，豆包成人版的个性化知识库功能让我能为每个客户建立独立的沟通档案，快速切换上下文，避免信息混淆。</p>
<h2>专业能力提升</h2>
<p>遇到不熟悉的领域，不再需要花大量时间学习。豆包成人版可以快速提供专业建议，让我能接更多类型的项目。</p>`,
    category: 'tutorials',
    image: 'https://readdy.ai/api/search-image?query=Freelancer%20working%20happily%20at%20cozy%20cafe%20with%20laptop%2C%20warm%20ambient%20lighting%2C%20minimalist%20modern%20workspace%2C%20independent%20professional%20lifestyle%2C%20calm%20and%20productive%20atmosphere&width=1200&height=600&seq=doubao-freelancer&orientation=landscape',
    author: '自由设计师林悦',
    date: '2026-08-03',
    readTime: '8分钟',
    tags: ['职场效率', '成人AI智能助手', '使用教程'],
  },
];

export const faqs = [
  {
    question: '豆包成人版和普通版有什么区别？',
    answer: '豆包成人版在内容深度、专业领域覆盖、对话记忆能力、个性化定制和输出质量五个方面全面升级。它专为成年人的职场效率、深度学习和复杂问题解决场景设计，提供更专业、更精准的AI智能支持。',
  },
  {
    question: '豆包成人版如何下载安装？',
    answer: 'iOS用户可在App Store搜索下载，Android用户可在各大应用商店或官网下载APK，桌面版支持Windows和macOS系统，均可在官网下载页面获取安装包。',
  },
  {
    question: '豆包成人版需要付费吗？',
    answer: '豆包成人版提供免费试用期，用户可以充分体验所有功能。试用期结束后可选择订阅高级版以继续使用全部专业功能，同时保留基础功能的免费使用权。',
  },
  {
    question: '豆包成人版的数据安全吗？',
    answer: '豆包成人版采用端到端加密传输，数据严格存储在境内服务器，符合国家数据安全法规。用户可随时查看、导出或删除个人数据，我们坚决保护用户隐私。',
  },
  {
    question: '豆包成人版支持哪些平台？',
    answer: '目前支持iOS、Android移动端，以及Windows和macOS桌面端。Web网页版也已上线，无需安装即可通过浏览器使用。所有平台数据实时同步。',
  },
  {
    question: '豆包成人版可以处理哪些类型的任务？',
    answer: '豆包成人版擅长文档撰写、数据分析、方案策划、市场研究、学术辅助、编程开发、翻译润色等多种专业任务，覆盖商业、科技、教育、法律、医疗等多个领域。',
  },
];

export const reviews = [
  {
    name: '张伟',
    role: '互联网公司产品总监',
    content: '用了豆包成人版三个月，写报告和做竞品分析的效率翻了一倍不止。现在部门里的同事都在用，已经成了我们团队的标配工具。',
    rating: 5,
  },
  {
    name: '李娜',
    role: '自由撰稿人',
    content: '豆包成人版帮我突破了写作瓶颈。以前每天最多写两篇深度文章，现在能稳定产出四到五篇，而且质量一点没降。',
    rating: 5,
  },
  {
    name: '王强',
    role: '创业公司CEO',
    content: '从商业计划书到投资人邮件，豆包成人版帮我把创业初期最头疼的文档工作都搞定了。专业度和效率远超预期。',
    rating: 5,
  },
  {
    name: '陈静',
    role: '高校研究生',
    content: '论文文献梳理和数据分析这块真的太强了。以前需要一周才能完成的文献综述，现在两天就能出初稿。',
    rating: 4,
  },
  {
    name: '刘洋',
    role: '律师事务所合伙人',
    content: '在法律检索和文书起草方面的能力让我惊喜。虽然不能替代专业判断，但作为辅助工具已经非常出色。',
    rating: 5,
  },
  {
    name: '赵敏',
    role: '市场营销经理',
    content: '策划方案、广告文案、数据分析，豆包成人版在我的日常工作中无处不在。营销人的效率神器！',
    rating: 5,
  },
];

export const features = [
  {
    icon: 'ri-brain-line',
    title: '深度对话模式',
    description: '多轮有记忆的复杂交流，理解上下文和真实意图，给出更具洞察力的专业回复。',
  },
  {
    icon: 'ri-file-text-line',
    title: '专业文档生成',
    description: '一键生成商业文档、学术论文、技术报告，内置多种专业模板，让创作事半功倍。',
  },
  {
    icon: 'ri-bar-chart-line',
    title: '数据分析助手',
    description: '自动分析数据、预测趋势、生成可视化报告，快速获得有价值的商业洞察。',
  },
  {
    icon: 'ri-translate-2',
    title: '专业翻译引擎',
    description: '覆盖商务、法律、医学等专业领域的精准翻译，术语准确、表达地道。',
  },
  {
    icon: 'ri-database-2-line',
    title: '个性化知识库',
    description: '构建专属知识库，AI越用越懂你，提供量身定制的个性化智能服务。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全隐私保护',
    description: '端到端加密传输，数据境内存储，透明数据处理政策，让你用得安心。',
  },
];

export const comparisonData = {
  dimensions: ['内容深度', '专业领域', '对话记忆', '个性化定制', '输出质量', '安全隐私', '多平台支持', 'API接口'],
  regular: [true, false, false, false, false, true, true, false],
  adult: [true, true, true, true, true, true, true, true],
};